import { InboxMessageCriteria } from '@src/main/modules/messages/domain/message/inbox/inbox-message-criteria.interface';
import { InboxMessage } from '@src/main/modules/messages/domain/message/inbox/inbox-message.interface';
import { InboxMessageRepository } from '@src/main/modules/messages/domain/message/inbox/inbox-message.repository';
import { InboxMessageEntity } from '@src/main/modules/messages/infrastructure/entity/inbox-message.entity';
import { parseInboxMessageCriteria } from '@src/main/modules/messages/infrastructure/mapper/message-criteria.mapper';
import { toInboxMessage } from '@src/main/modules/messages/infrastructure/mapper/message.mapper';
import { api, TokenProvider } from '@src/main/shared/infrastructure/entity/axios';
import { PageResponse } from '@src/main/shared/infrastructure/entity/page.entity';

export const createInboxMessageHttpRepository = (
  tokenProvider: TokenProvider,
): InboxMessageRepository => new InboxMessageHttpRepository(tokenProvider);

class InboxMessageHttpRepository implements InboxMessageRepository {
  private readonly tokenProvider: TokenProvider;

  constructor(tokenProvider: TokenProvider) {
    this.tokenProvider = tokenProvider;
  }

  private async getAuthToken(): Promise<string> {
    const token = await this.tokenProvider.getToken();
    if (!token) {
      throw new Error('Authentication token is missing');
    }
    return token;
  }

  async findByCriteria(criteria: InboxMessageCriteria): Promise<PageResponse<InboxMessage>> {
    const token = await this.getAuthToken();
    const params = parseInboxMessageCriteria(criteria);
    const response = await api.get<PageResponse<InboxMessageEntity>>('/messages', token, params);
    return {
      ...response,
      items: response.items.map(toInboxMessage),
    };
  }

  async findById(id: string): Promise<InboxMessage> {
    const token = await this.getAuthToken();
    return await api.get<InboxMessage>(`/messages/${id}`, token);
  }

  async findBySendBy(id: string): Promise<InboxMessage> {
    const token = await this.getAuthToken();
    return await api.get<InboxMessage>(`/messages/send_by/${id}`, token);
  }

  async readMessage(messageId: string): Promise<InboxMessage> {
    const token = await this.getAuthToken();
    return await api.put<InboxMessage>(`/messages/read/${messageId}`, token, null);
  }
}
